import { useIntl } from "react-intl";
import { useCallback } from "react";
import { GenderValue } from "shared";

export type TranslateByGender = (
  id: string,
  translationParams?: { [key: string]: string },
) => string;

export const useTranslateByGender = (gender?: string) => {
  const intl = useIntl();

  const translate: TranslateByGender = useCallback(
    (id: string, _translationParams?: { [key: string]: string }) => {
      try {
        // Adding gender support for translation, checking if term has gender support and if so it uses it
        let formatId = id;

        if (!intl?.messages) return "";
        if (gender === GenderValue.MALE && intl.messages[id + "_MALE"]) {
          formatId = id + "_MALE";
        } else if (
          gender === GenderValue.FEMALE &&
          intl.messages[id + "_FEMALE"]
        ) {
          formatId = id + "_FEMALE";
        }

        const translated_app_name =
          id === "APP_NAME" ? {} : { APP_NAME: translate("APP_NAME") };

        const translationParams = {
          ...(_translationParams || {}),
          ...translated_app_name,
        };

        // Allow overriding translations to empty strings
        if (intl.messages[formatId] === "") return "";

        const idExists = !!intl.messages[formatId];

        const translation = intl.formatMessage(
          {
            id: idExists ? formatId : id,
          },
          translationParams,
        );
        return translation;
      } catch (e) {
        console.warn(e);
        return id;
      }
    },
    [intl, gender],
  );

  return { translate, locale: intl.locale };
};
